import {
  Component,
  ElementRef,
  forwardRef,
  HostBinding,
  Inject,
  Input,
  OnDestroy,
  OnInit,
  ViewChild
} from '@angular/core';
import { MUser } from '@argalis-apps/models';
import { AccountConfigService } from '../../../services/account-config/account-config.service';
import { AuthService } from '../../../../auth/services/auth/auth.service';
import { Router } from '@angular/router';


@Component({
  selector: 'ags-account-fiche-formation',
  templateUrl: './fiche-formation.component.html',
  styleUrls: ['./fiche-formation.component.scss']
})
export class FicheFormationComponent implements OnInit, OnDestroy {
  @HostBinding('class') themeFlag: string;
  @ViewChild('formation') formation: ElementRef<HTMLElement>;
  @Input('idFormation')
  set _idFormation(value: number) {
    this.idFormation = value;
  }

  private userConnected: MUser.CUser = null;
  public displayFormation = true;
  public displayPlanning = false;
  public displayApprenant = false;
  public displayDoc = false;
  public idFormation: number;

  constructor(
    @Inject(forwardRef(() => AuthService)) private authService: AuthService,
    @Inject(forwardRef(() => AccountConfigService)) private accountConfigService: AccountConfigService,
    private router: Router
  ) {
    this.userConnected = this.authService.userConnected;
    this.authService.userChange.subscribe((user: MUser.CUser) => {
      this.userConnected = user;
    });
  }

  ngOnInit() {
    this.formation.nativeElement.focus();
    this.themeFlag = `${this.themeFlag || ''} ${this.accountConfigService.themingClassName}`;
    if (!this.userConnected) {
      this.router.navigate(['/'], {});
    }
  }

  gotToFormation($event: MouseEvent) {
    this.displayFormation = true;
    this.displayPlanning = false;
    this.displayApprenant = false;
    this.displayDoc = false;
  }

  gotToPlanning($event: MouseEvent) {
    this.displayFormation = false;
    this.displayPlanning = true;
    this.displayApprenant = false;
    this.displayDoc = false;
  }

  gotToApprenant($event: MouseEvent) {
    this.displayFormation = false;
    this.displayPlanning = false;
    this.displayApprenant = true;
    this.displayDoc = false;
  }

  goToDoc($event: MouseEvent) {
    this.displayFormation = false;
    this.displayPlanning = false;
    this.displayApprenant = false;
    this.displayDoc = true;
  }
  ngOnDestroy(): void {
    this.displayFormation = true;
    this.displayPlanning = false;
    this.displayApprenant = false;
    this.displayDoc = false;
  }
}
